import { render, staticRenderFns } from "./fullCalendarApp.vue?vue&type=template&id=503e4f50&lang=html"
import script from "./fullCalendarApp.vue?vue&type=script&lang=js"
export * from "./fullCalendarApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports